// import { Flex } from "@aws-amplify/ui-react"
// import { FaAngleDown, FaSliders } from "react-icons/fa6"

export const FilterAndSort = () => {
  return <></>
  // return <Flex justifyContent="space-between">
  //   <div className="filter"><FaSliders /> Filtern</div>
  //   <div className="sort">Sortieren <FaAngleDown /></div>
  // </Flex>
}
